module.exports = flarum.core.compat['components/DiscussionPage'];